import { render, staticRenderFns } from "./BookmakersList.vue?vue&type=template&id=25e85c20&"
import script from "./BookmakersList.vue?vue&type=script&lang=ts&"
export * from "./BookmakersList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports